module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changeTo":"Select new loan status","changeStatusConfirm":"Are you sure to change status?"},"et":{"changeTo":"Select new loan status","changeStatusConfirm":"Are you sure to change status?"},"ru":{"changeTo":"Select new loan status","changeStatusConfirm":"Are you sure to change status?"}}')
  delete Component.options._Ctor
}
